import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // message: 'Hello Vuex',
    filter: {
      all: '',
      // mat: [],
      // wid: [],
      // col: [],
      // des: [],
      // hee: [],
    },
  },
  mutations: {
    setAll: function (state, num) {
      state.filter.all = num;
    },
    // setMat: function (state, array) {
    //   state.filter.mat = array;
    // },
    // setWid: function (state, array) {
    //   state.filter.wid = array;
    // },
    // setCol: function (state, array) {
    //   state.filter.col = array;
    // },
    // setDes: function (state, array) {
    //   state.filter.des = array;
    // },
    // setHee: function (state, array) {
    //   state.filter.hee = array;
    // },
  },
  actions: {
  },
  modules: {
  }
})
